import { useEffect, useState } from 'react';

import { Box, Typography } from '@mui/material';

import NavSolicitation from './NavSolicitation';
import FadeAnimation from 'components/views/FadeAnimation';

import { ReactComponent as IcChatOnline } from 'assets/icons/ic-chat-online.svg';
import { ReactComponent as IcTechnicalSupport } from 'assets/icons/ic-technical-support.svg';
import { ReactComponent as IcIturinUnavailable } from 'assets/icons/ic-iturin-unavailable.svg';

import { Ul } from './styles';

const textStyle = {
    fontSize: '.9375rem',
}

const textStyleError = {
    fontSize: '.9375rem',
    fontWeight: 600
}

const TechnicalSupport = () => {
    const dateNow = new Date();

    const [serviceAvailable, setServiceAvailable] = useState(false);

    useEffect(() => {
        if (dateNow.getDay() > 0) {
            if (dateNow.getDay() === 6 && dateNow.getHours() < 14 && dateNow.getHours() > 7) {
                setServiceAvailable(true);
            } else if (dateNow.getDay() < 6 && dateNow.getHours() < 18 && dateNow.getHours() > 7) {
                setServiceAvailable(true);
            } else {
                setServiceAvailable(false);
            }
        } else {
            setServiceAvailable(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <FadeAnimation>
            <Box>
                <NavSolicitation title='Suporte técnico' icon={<IcTechnicalSupport />} />
                <Typography sx={textStyle} paddingBottom='.5rem'>
                    Entre em contato com nossa equipe de atendimento técnico, para:
                </Typography>
                <Ul>
                    <li>
                        <Typography sx={textStyle}>
                            Agendar manutenção do seu equipamento;
                        </Typography>
                    </li>
                    <li>
                        <Typography sx={textStyle}>
                            Retorno de sms ou e-mail;
                        </Typography>
                    </li>
                    <li>
                        <Typography sx={textStyle}>
                            Dúvidas técnicas ou problemas técnicos relacionados ao seu rastreador.
                        </Typography>
                    </li>
                </Ul>
                {serviceAvailable ?
                    <Box sx={{ display: 'flex', width: '100%', flexDirection: 'column', alignItems: 'center' }}>
                        <a href="https://api.whatsapp.com/send/?phone=551136169000" target='blank'>
                            <IcChatOnline />
                        </a>
                        <Typography sx={{ fontSize: '.875rem', margin: '1rem 0 2.6875rem', fontWeight: 600, textAlign: 'center', lineHeight: '1.6' }}>
                            Opção - Dúvidas Técnicas
                            <br />
                            Atendimento de Segunda à Sexta das 08h às 18h e Sábado das 08h às 14h
                        </Typography>
                    </Box>
                    :
                    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                        <IcIturinUnavailable />
                        <Box sx={{
                            border: '1.5px solid rgba(10, 168, 227, 0.45)',
                            borderRadius: '10px',
                            maxWidth: '21.875rem',
                            padding: '1.5625rem 2rem',
                            marginTop: '-30px',
                            backgroundColor: 'white',
                            textAlign: 'center'
                        }}>
                            <Typography sx={textStyleError} paddingBottom='.875rem'>
                                Prezado cliente, nosso horário de<br />
                                atendimento é de:
                            </Typography>

                            <Ul>
                                <li>
                                    <Typography sx={textStyleError}>
                                        Segunda a sexta das 8h às 18h
                                    </Typography>
                                </li>
                                <li>
                                    <Typography sx={textStyleError}>
                                        Sábado das 8h às 14h
                                    </Typography>
                                </li>
                            </Ul>

                            <Typography sx={textStyleError} marginTop='-.5625rem'>
                                Entre em contato novamente.
                            </Typography>
                        </Box>
                    </Box>
                }
            </Box>
        </FadeAnimation>
    );
}

export default TechnicalSupport;